.title {
  font-size: 14px;
  font-weight: 500;
  display: flex;
}

.info {
  font-size: 11px;
  line-height: 1.2em;
  color: var(--color-black-50);
  margin-top: 2px;
}

.price {
  font-size: 11px;
  line-height: 1.2em;
  color: var(--color-black-50);
  margin-top: 2px;
  font-weight: 700;
}

.disableOption {
  display: inline-block;
  align-self: flex-start;
  color: white;
  background: black;
  font-size: 11px;
  font-weight: 600;
  line-height: 12px;
  text-transform: uppercase;
  border-radius: var(--border-radius);
  padding: 4px 6px 3px;
}

.fullWidth {
  width: 100%;
}

.capacityWrapper {
  width: auto;
  display: flex;
  align-items: center;
}

.separator {
  width: 3px;
  height: 3px;
  margin:5px;
  border-radius: 3px;
  background-color: grey;
}

.capacity {
  height: 13px;
  margin-right:3px;
}

.capacityNumber {
  font-size: 12px;
  color:grey;
}
